import { BarChart3, FileText, Headphones, MessageSquare, Receipt, Send, type LucideIcon } from "lucide-react";

/** Icon per example agent id in the copy JSON (`hero.agents`). */
export const AGENT_ICONS: Record<string, LucideIcon> = {
  sales: MessageSquare,
  finance: Receipt,
  report: BarChart3,
  followup: Send,
  support: Headphones,
  quote: FileText,
};
